export enum REFERRERS_DEFAULT_FIELDS {
  PROFESSIONS = 'PROFESSIONS',
  BANK = 'BANK',
  BRANCH = 'BRANCH',
}
